function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.245.818a2.783 2.783 0 014.066 3.796l-.13.14-9.606 9.605a2 2 0 01-.723.463l-.165.052L.632 15.98a.5.5 0 01-.63-.534l.016-.08 1.106-4.055a2 2 0 01.398-.76l.117-.128L11.245.818zm-.86 2.274L2.346 11.13a1 1 0 00-.215.322l-.042.123-.877 3.21 3.212-.875a1 1 0 00.239-.1l.107-.072.098-.086 8.038-8.039-2.521-2.52zm4.088-1.567a1.783 1.783 0 00-2.401-.11l-.12.11-.86.86 2.52 2.521.861-.86a1.783 1.783 0 00.11-2.401l-.11-.12z",
  fill: "#212121"
});

function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgEditIcon;